import React, { useEffect, useState } from "react";
import GlobalStyle from "./style/Globalstyle";
import { useDispatch } from "react-redux";
import { getCategory } from "./redux/categorySlice";
import { getProducts } from "./redux/productsSlice";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";

const App = ({ id }) => {
  const dispatch = useDispatch();
  const [resto, setResto] = useState("");
  const [resim1, setResim1] = useState("");
  const [resim2, setResim2] = useState("");
  const [resim3, setResim3] = useState("");
  const [resim4, setResim4] = useState("");
  const [resim5, setResim5] = useState("");
  const [resim6, setResim6] = useState("");
  const [resim7, setResim7] = useState("");

  const url =
    "https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/restaurant_pictures/" +
    id +
    "/";

  useEffect(() => {
    const restaurant_data = async () => {
      const data = {
        path: id + "/restaurant.json",
      };
      await fetch("https://api.mobrespos.com/get_image", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Accept: "application/json",
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((datax) => {
          setResto(() => datax[0]);
        });

      fetch(url + "1").then((data) => {
        data.text().then((text) => setResim1(text));
      });

      fetch(url + "2").then((data) => {
        data.text().then((text) => setResim2(text));
      });
      fetch(url + "3").then((data) => {
        data.text().then((text) => setResim3(text));
      });
      fetch(url + "4").then((data) => {
        data.text().then((text) => setResim4(text));
      });
    };

    if (id) {
      restaurant_data();
      const data1 = { path: id + "/categoryno.json" };
      const data2 = { path: id + "/productsno.json" };
      restaurant_data();
      dispatch(getCategory(data1));
      dispatch(getProducts(data2));
    }
  }, [dispatch, url, id]);

  return (
    <>
      <GlobalStyle />
      {resto ? (
        <Routes>
          <Route
            path="/"
            element={
              <Home
                resto={resto}
                id={id}
                resim1={resim1}
                resim2={resim2}
                resim3={resim3}
                resim4={resim4}
                resim5={resim5}
                resim6={resim6}
                resim7={resim7}
              />
            }
          />
        </Routes>
      ) : (
        " Yükleniyor..."
      )}
    </>
  );
};

export default App;
